import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { spacing, breakpoints } from '@naf/theme';
import { Input, DateWrapper } from '@naf/input';
import { GridCol } from '@naf/grid';

const formFieldMaxWidth = '544px';
const twoColumnGap = spacing.space16;

const Heading = styled(Text)`
  margin: 0;
`;

const FieldWrapper = styled.div`
  margin-top: ${spacing.space12};
`;

const ControllersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spacing.space12} ${twoColumnGap};
  width: 100%;
  max-width: ${formFieldMaxWidth};
  margin-top: ${spacing.space16};

  > div {
    min-width: 0;
    width: 100%;
  }

  > div > ${FieldWrapper} {
    margin-top: 0;
  }

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: 1fr;

    > div {
      width: 100%;
    }
  }
`;

const FullWidthFieldWrapper = styled.div`
  margin-top: ${spacing.space16};
  width: 100%;
  max-width: ${formFieldMaxWidth};
`;

const FlexWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  max-width: ${formFieldMaxWidth};
  margin-top: ${spacing.space16};
  gap: ${spacing.space12};

  > div {
    min-width: 0;
  }

  > div > ${FieldWrapper} {
    margin-top: 0;
  }
`;

const FirstName = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const LastName = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const ResponsiveTextField = styled(Input)`
  width: 100%;
`;

const FullWidthTextField = styled(Input)`
  width: 100%;

  @media (min-width: ${breakpoints.m}) {
    max-width: ${formFieldMaxWidth};
  }
`;

const BirthDateWrapper = styled(DateWrapper)`
  min-width: 0;
  width: 100%;

  > label {
    margin: 0;
  }

  > :nth-child(n + 2) {
    margin-right: 0;
  }

  > :nth-child(2),
  > :nth-child(3) {
    margin-right: ${spacing.space12};
  }
`;

const Zip = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const City = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const BirthCity = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const BirthCountry = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const PhoneNumber = styled.div`
  min-width: 0;

  @media (min-width: ${breakpoints.m}) {
    display: block;
  }
`;

const AddressWrapper = styled.div`
  width: 100%;
  max-width: ${formFieldMaxWidth};

  > div {
    max-width: 100%;
    margin-top: ${spacing.space12};
  }
`;

const LogIn = styled.div`
  margin-top: ${spacing.space24};
  display: flex;
  justify-content: flex-end;
`;

const ResponsiveCol = styled(GridCol)`
  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

const Line = styled.span`
  height: 1px;
  display: flex;
  background-color: #000;
  opacity: 0.12;
`;

const AlreadyAMemberWrapper = styled.div`
  margin-top: -${spacing.space32};
  margin-bottom: ${spacing.space24};
`;

export default {
  Heading,
  ControllersWrapper,
  FieldWrapper,
  FullWidthFieldWrapper,
  FirstName,
  LastName,
  ResponsiveTextField,
  FullWidthTextField,
  BirthDateWrapper,
  Zip,
  City,
  BirthCity,
  BirthCountry,
  PhoneNumber,
  AddressWrapper,
  LogIn,
  ResponsiveCol,
  Line,
  FlexWrapper,
  AlreadyAMemberWrapper,
};
